import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';
import { Link } from 'react-router-dom';
import { setCookieConsent, getCookieConsent } from '@/utils/cookieConsent';

export const CookieBanner = () => {
  const { t } = useTranslation();
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    const cookieConsent = getCookieConsent();
    if (!cookieConsent) {
      setShowBanner(true);
    }
  }, []);

  const handleAccept = () => {
    setCookieConsent('accepted');
    setShowBanner(false);
  };

  const handleReject = () => {
    setCookieConsent('rejected');
    setShowBanner(false);
  };

  if (!showBanner) return null;

  return (
    <div className="fixed bottom-0 z-40 inset-x-0 mx-4 mb-4">
      <div className="bg-gray-900/60 backdrop-blur rounded-lg border border-white/10 p-4 shadow-2xl max-w-4xl mx-auto">
        <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4">
          <div className="flex-1">
            <p className="text-sm text-white">
              {t('cookieBanner.description')}{' '}
              <Link 
                to="/cookie-policy" 
                className="text-blue-300 hover:text-blue-200 hover:underline"
              >
                {t('cookieBanner.learnMore')}
              </Link>
            </p>
          </div>
          
          <div className="flex gap-3 w-full sm:w-auto">
            <Button
              variant="outline"
              size="sm"
              onClick={handleReject}
              className="flex-1 sm:flex-none"
            >
              {t('cookieBanner.reject')}
            </Button>
            <Button
              size="sm"
              onClick={handleAccept}
              className="flex-1 sm:flex-none bg-newsletter-primary hover:bg-newsletter-primary/90"
            >
              {t('cookieBanner.accept')}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};